import React, { Component } from "react";
import { db } from "../config";
import { highestQualification, ngStates } from "../selectData";
import ApplicantTable from "../components/ApplicantTable";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { selectedApplicants } from "../actions";

class Applicants extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      job: null,
      jobId: this.props.match.params.id,
      nigeriaStates: [],
      applicants: [],
      applicantsBackup: [], //used to return to default after search and sort
      error: false,
      maxAge: "",
      grade: "",
      highestQualification: "",
      stateOfOrigin: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.createReport = this.createReport.bind(this);
  }

  createReport() {
    this.setState({ loading: true });
    this.props.dispatch(selectedApplicants(this.state.applicants));
    setTimeout(() => this.props.history.push("/report"), 3000);
  }

  handleChange(name) {
    return e => {
      this.setState({ [name]: e.target.value });
      if (!e.target.value) {
        this.setState({ applicants: this.state.applicantsBackup });
      }
    };
  }

  handleReset() {
    this.setState({ applicants: this.state.applicantsBackup });
  }

  handleFilter() {
    // database collection id
    // todo: still buggy
    /*db.collection(this.state.jobId)
      .where("stateOfOrigin", "==", this.state.stateOfOrigin)
      .where("age", "<=", Number(this.state.maxAge) || true)
      .get()
      .then(snap => {
        let temp = []
        snap.forEach(doc => {
          temp.push(doc.data())
        })
        this.setState({applicants: temp})
      }) */

    let fil;

    const hq = this.state.highestQualification;
    const stateOfOrigin = this.state.stateOfOrigin;
    const maxAge = Number(this.state.maxAge);
    const grade = Number(this.state.grade);

    if (hq) {
      fil = this.state.applicants.filter(
        x => x.highestQualification.toLowerCase() === hq.toLowerCase()
      );
    }

    if (stateOfOrigin) {
      if (fil && fil.length)
        fil = fil.filter(x => x.stateOfOrigin === stateOfOrigin);
      else {
        fil = this.state.applicants.filter(
          x => x.stateOfOrigin === stateOfOrigin
        );
      }
    }

    if (grade) {
      if (fil && fil.length) fil = fil.filter(x => x.grade && x.grade >= grade);
      else {
        fil = this.state.applicants.filter(x => x.grade && x.grade >= grade);
      }
    }

    if (this.state.maxAge) {
      if (fil && fil.length) fil = fil.filter(x => x.age <= maxAge);
      else {
        fil = this.state.applicants.filter(x => x.age <= maxAge);
      }
    }

    if (fil && fil.length) {
      this.setState({ applicants: fil });
    }
  }

  handleSearch(e) {
    const val = e.target.value;
    let fil;
    if (val) {
      fil = this.state.applicants.filter(
        x =>
          x.firstname.toLowerCase().includes(val.toLowerCase()) ||
          x.lastname.toLowerCase().includes(val.toLowerCase()) ||
          x.stateOfOrigin.toLowerCase().includes(val.toLowerCase()) ||
          x.highestQualification.toLowerCase().includes(val.toLowerCase()) ||
          (x.course && x.course.toLowerCase().includes(val.toLowerCase()))
      );
      this.setState({ applicants: fil });
    } else {
      this.setState({ applicants: this.state.applicantsBackup });
    }
  }

  componentDidMount() {
    // get single job
    db
      .collection("jobs")
      .where("id", "==", this.state.jobId)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          // contains only single doc
          this.setState({ job: doc.data() });
        });
      })
      .then(() => {
        // get all applicants
        // id is the collection name for applicants for this job
        db
          .collection(this.state.jobId)
          .get()
          .then(querySnapshot => {
            let applicants = [];
            querySnapshot.forEach(doc => {
              applicants.push(doc.data());
            });
            this.setState({ applicants, applicantsBackup: applicants });
          });
      })
      .catch(e => this.setState({ error: e }));
  }

  render() {
    const { applicants, loading } = this.state;
    return (
      <div className="pa2 pb5" style={{ minHeight: 400 }}>
        <div className="columns is-multiline bg-white shadow-lg">
          <div className="column is-narrow">
            <Link
              to={`/office/edit-job/${this.props.match.params.id}`}
              className="button is-white is-small is-light"
            >
              Edit Job
            </Link>
            <button className="button is-danger ml3 is-small">
              Delete Job
            </button>
          </div>
          <div className="column">
            <div className="field ph5-l mh5-l">
              <div className="control">
                <input
                  className="input"
                  type="text"
                  placeholder="Search by name, state, qualification course"
                  onChange={this.handleSearch}
                />
              </div>
            </div>
          </div>
          <div className="column is-narrow is-offset-2">
            <p>
              <i className="fa fa-print f4 dim" />
            </p>
          </div>
        </div>

        <div className="bg-white pa2">
          <div className="field is-horizontal">
            <div className="field-body">
              <label className="fw5 f5 pr2 pt2">Highest Qualification</label>
              <div className="field is-narrow">
                <div className="control">
                  <div className="select">
                    <select
                      onChange={this.handleChange("highestQualification")}
                    >
                      <option value="">All</option>
                      {highestQualification.map((x, i) => (
                        <option key={i} value={x}>
                          {x}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <label className="fw5 f5 pr2 pt2">State</label>
              <div className="field is-narrow">
                <div className="control">
                  <div className="select">
                    <select onChange={this.handleChange("stateOfOrigin")}>
                      <option>Select</option>
                      {ngStates.map((st, i) => (
                        <option key={i} value={st}>
                          {st}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <label className="fw5 f5 pr2 pt2">Min Grade</label>
              <div className="field is-narrow">
                <div className="control">
                  <div className="select">
                    <select onChange={this.handleChange("grade")}>
                      <option>select</option>
                      <option value="4.5">First class</option>
                      <option value="3.5">Second class upper division</option>
                      <option value="2.4">Second class lower division</option>
                      <option value="1.5">Thirs class</option>
                      <option value="0">Other</option>
                    </select>
                  </div>
                </div>
              </div>

              <label className="fw5 f5 pr2 pt2">Max age</label>
              <div className="field is-narrow">
                <div className="control">
                  <input
                    style={{ width: 100 }}
                    className="input"
                    type="text"
                    onChange={this.handleChange("maxAge")}
                  />
                </div>
              </div>

              <button
                onClick={this.handleFilter}
                className="button is-link mr1"
              >
                Filter
              </button>

              <button onClick={this.handleReset} className="button is-link">
                Reset
              </button>

              <button
                onClick={this.createReport}
                className={`button is-link ml1 ${loading && "is-loading"}`}
              >
                Create Report
              </button>
            </div>
          </div>
        </div>

        <section className="mt4 bg-white">
          <ApplicantTable data={applicants} jobId={this.state.jobId} />
        </section>
      </div>
    );
  }
}

export default connect()(Applicants);



// WEBPACK FOOTER //
// ./src/pages/applicants.js